import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiEquipmentsList, apiEquipmentsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/equipments/getData', async datas => {
    const { data } = await apiEquipmentsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/equipments/getView', async id => {
    if (!id) return viewData
    const { data } = await apiEquipmentsView(id)
    return data
})

const viewData = {
    name: '',
    make_type: '',
    manufacturer_no: '',
    identification_no: '',
    range: '',
    calibration_on: '',
    calibration_due_on: '',
    frequency_of_calibration: '',
    calibration_agency: '',
    remarks: '',
}

export const equipmentsSlice = createSlice({
    name: 'admin/equipments',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: '',
            end: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = equipmentsSlice.actions

export default equipmentsSlice.reducer
